import { ErrorResponseDto } from "@desio/api";
import { createAction } from "@reduxjs/toolkit";

export const showLoader = createAction<string | undefined, 'general/showLoader'>('general/showLoader');
export const hideLoader = createAction<string | undefined, 'general/hideLoader'>('general/hideLoader');

export const setGeneralError = createAction<ErrorResponseDto, 'general/setGeneralError'>('general/setGeneralError');
export const resetGeneralError = createAction<void, 'general/resetGeneralError'>('general/resetGeneralError');

// export const setInputRicercaNdgCedacri = createAction<string, 'setInputRicercaNdgCedacri'>('setInputRicercaNdgCedacri');

